import { Pipe, PipeTransform } from '@angular/core';

import { meses } from '../../../models/mes';

@Pipe({
    name: 'mesAbreviacao'
})
export class MesAbreviacaoPipe implements PipeTransform {
    transform(mes: number): string {
        if (!mes) {
            return '';
        }

        const index = meses.findIndex(mesFilter => mesFilter.mes === mes);
        if (index > -1) {
            return meses[index].abreviacao;
        }
        return '';
    }
}
